import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';

interface IAttributeCodeEngineConfig {
    codes: string[];
    logic: NProductConfiguration.Configurable.TRuleLogic;
}

export const configurableAttributeCodeEngine: NProductConfiguration.Configurable.EngineGenerator<IAttributeCodeEngineConfig> = (
    engineConfig: IAttributeCodeEngineConfig
) => {
    return (attributeCode: string, value: number) => {
        if (engineConfig.codes.includes(attributeCode)) {
            return engineConfig.logic;
        }
        return undefined;
    };
};
